/**
 * Google Analytics (gtag.js) for the creator dashboard only. Buyer- and
 * member-facing pages (/g/, /p/, /buy/, /experiences/, /thank-you) and the
 * legal pages never load it; the privacy policy says so.
 */

export const GA_MEASUREMENT_ID = 'G-NMP9ZC01FH';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let loaded = false;

/** Load gtag.js once and send the initial page view. */
export function loadGoogleAnalytics(): void {
  if (loaded || typeof window === 'undefined') return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  // gtag.js reads the `arguments` object, not an array; keep the documented shape.
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}
